/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Dashboard_Kpi_Members_BadgeInputs */



/**
* | output |
* | --- |
* | "{count} used AI this period" |
*
* @param {Partner_Dashboard_Kpi_Members_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_dashboard_kpi_members_badge = /** @type {((inputs: Partner_Dashboard_Kpi_Members_BadgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Dashboard_Kpi_Members_BadgeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} haben KI genutzt`)
	return /** @type {LocalizedString} */ (`${i?.count} used AI this period`)
});